var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tip",on:{"click":_vm.go}},[_vm._v(" 备案号 鄂ICP备2020020018号-1 ")])}
var staticRenderFns = []

export { render, staticRenderFns }